import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${Spacing.SINGLE};
  margin-top: 24px;

  & > * {
    padding: 0;
    margin: 0;
  }
`;

export const MenuBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 0 ${Spacing.SINGLE};
`;

export const Header = styled.h3`
  margin-bottom: ${Spacing.SINGLE};
`;
